import Swiper, { Lazy, Navigation } from "swiper";

const WooCommon = {
  init() {
    this.events();
    this.updateCart();
    this.quantity();
    this.notice();
    this.relatedProjectsSlider();
  },

  events() {
    $(".woocommerce-remove-coupon, [name=apply_coupon]").on("click", () => {
      $(".cart-page").addClass("loading");
    });
  },

  updateCart() {
    var timeout;

    $(".woocommerce").on("change", "input.qty", function () {
      if (timeout !== undefined) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(function () {
        $(".cart-page").addClass("loading");
        $("[name='update_cart']").trigger("click");
      }, 1500);
    });
  },

  quantity() {
    const quantity = $(".quantity");
    if (quantity.length) {
      // Add
      $(".quantity__button--up").on("click", function () {
        const input = $(this).closest(".quantity").find("input");
        let current = parseInt(input.val());
        if (parseInt(input.attr("max")) > 0) {
          +input.attr("max") > current ? current++ : current;
        } else {
          current++;
        }
        input.val(current);
        input.change();
      });

      // Substract
      $(".quantity__button--down").on("click", function () {
        const input = $(this).closest(".quantity").find("input");
        let current = parseInt(input.val());
        +input.attr("min") < current ? current-- : current;
        input.val(current);
        input.change();
      });

      // Input change
      $(".quantity__input").on("input", function (e) {
        const input = $(this);

        let current = parseInt(input.val());
        let min = parseInt(input.attr("min"));
        let max = parseInt(input.attr("max"));

        if (current < min) {
          current = min;
        }
        if (max > 0 && current > max) {
          current = max;
        }

        input.val(current);
      });
    }
  },

  notice() {
    const noticeEl = $(
      ".wc-block-components-notice-banner.show-popup:not(.is-error)"
    );
    if (!noticeEl.length) {
      return;
    }

    noticeEl.each(function () {
      const item = $(this);
      if (item.parent().hasClass("wc-empty-cart-message")) {
        return;
      }

      setTimeout(function () {
        item.toggleClass("hidden");
      }, 4000);
    });
  },

  relatedProjectsSlider() {
    const relatedEl = $(".projects-slider");
    if (!relatedEl.length) {
      return;
    }

    let count = relatedEl.find(".project").length;

    let swiperInstance;

    function initializeSwiper() {
      let navEl = ".slider-nav";
      if (window.innerWidth < 900) {
        navEl = ".slider-nav--mobile";
      }

      const sliderEl = relatedEl.find(".swiper");

      swiperInstance = new Swiper(sliderEl[0], {
        modules: [Lazy, Navigation],
        loop: false,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
        navigation: {
          prevEl: relatedEl.find(`${navEl} .slider-nav__btn-prev`)[0],
          nextEl: relatedEl.find(`${navEl} .slider-nav__btn-next`)[0],
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          480: {
            slidesPerView: count < 4 ? 1 : 2,
          },
          900: {
            slidesPerView: count < 4 ? 2 : 3,
          },
          1200: {
            slidesPerView: count < 4 ? 3 : 4,
          },
        },
      });
    }

    initializeSwiper(); // Initialize Swiper initially

    // Update Swiper on window resize
    $(window).on("resize", function () {
      // Destroy previous instance if it exists
      if (swiperInstance) {
        swiperInstance.destroy();
      }
      // Reinitialize Swiper with updated options
      initializeSwiper();
    });
  },
};

export default WooCommon;
